module.exports = __webpack_public_path__ + "media/images/360/circadian_rhytm_mimosa_pudica-5529ff44f72e51a81441513b39f0cf0a.jpg";